import { Player } from '@lottiefiles/react-lottie-player';

import { settings } from '@/_config';
import WatchAnimation from '@/_shared/animations/a_watch.json';
import swa_WatchAnimation from '@/_shared/animations/swa_animation.json';

export default function AnimationPlayer({
  animation = settings.isSWA ? swa_WatchAnimation : WatchAnimation,
  height = 144,
  width = 144,
  loop = true,
  autoplay = true,
}) {
  return <Player autoplay={autoplay} loop={loop} src={animation} style={{ height, width }} />;
}
